import { compile } from "vue";

const moduleRoute = {
  path: "/admin",
  name: "admin",
  redirect: '/admin/tenants',
  meta: {
    module: "admin",
    requiresAuth: true
  },
  component: () => import("./adminModule.vue"),
  children: [
    {
      path: "/admin/users",
      name: "users",
      meta: { 
        showInNav: true,
        icon: 'mdi-account-multiple',
        breadcrumb: 
        {
          label: 'Users',
        } 
      },
      component: () => import(/* webpackChunkName: "users" */'./views/UsersListView.vue')
    },
    {
      path: "/admin/users/:id",
      name: "user-details",
      meta: { 
        breadcrumb: 
        {
          label: 'User Details',
          parent: 'users'
        } 
      },
      component: () => import (/* webpackChunkName: "user-details" */ "./views/UserDetailView.vue"),
    },
    {
      path: "/admin/tenants",
      name: "tenants",
      meta: {
        showInNav: true,
        icon: 'mdi-domain',
        breadcrumb:
        {
          label: 'Tenants',
        }
      },
      component: () => import(/* webpackChunkName: "users" */'./views/TenantsListView.vue')
    },
    {
      path: "/admin/tenants/new",
      name: "tenant-wizard",
      meta: { breadcrumb:
        {
          label: 'Add Tenant',
          parent: 'tenants'
        }
      },
      component: () => import ("./views/NewTenantWizard.vue"),
    },
    {
      path: "/admin/tenants/:id",
      name: "tenant-details",
      meta: { breadcrumb:
        {
          label: 'Tenant Details',
          parent: 'tenants'
        } 
      },
      component: () => import (/* webpackChunkName: "user-details" */ "./views/TenantDetailDashboardView.vue"),
    },
    {
      path: "/admin/dashboard-configs",
      name: "admin.dashboard-configs",
      meta: {
        breadcrumb: {
          label: 'Dashboard Configurations',
          parent: 'admin'
        }
      },
      component: () => import(/* webpackChunkName: "dashboard-configs" */ "./views/DashboardConfigListView.vue")
    },
    {
      path: "/admin/test",
      name: "admin.test",
      meta: { breadcrumb:{
        label: 'Test',
      }},
      component: () => import( "./views/TestGridView.vue")
    },
    {
      path: "/admin/system",
      name: "admin.system",
      meta: {
        showInNav: false,
        icon: 'mdi-cog-outline',
        breadcrumb: {
          label: 'System Settings',
        }
      },
      component: () => import(/* webpackChunkName: "system-settings" */ "./views/SystemSettingsView.vue")
    }
  ]
};


export default router => {
  router.addRoute(moduleRoute)
  return moduleRoute
}
